import { css } from 'styled-components';

import { focusOutlineColors } from './../core';

export const pageHeaderNavigationTabStateStyles = {
  focus: css`
    box-shadow: inset 0 0 0 4px ${({ theme }) => focusOutlineColors.getDark(theme)};
  `,
};
